import { formatDistanceToNow } from 'date-fns'
import { bool, func, string, object } from 'prop-types'
import { Fragment } from 'react'
import { ConnectedUserMenu } from '@opallabs/beacon'
import {
  Button,
  Conditional,
  renderIcon,
  kuiperClassNames,
} from '@opallabs/kuiper'
import { decorateServiceName } from '@opallabs/wormhole'
import './styles.scss'

const LayerHeader = ({
  avatarVisible = true,
  channelName,
  createdByUser,
  hideSupportButtons,
  isLatest,
  onLatestClick,
  postTitle,
  snapshotCreatedAt,
  theme,
}) => (
  <Fragment>
    <div className={kuiperClassNames('navigation-items')}>
      <ConnectedUserMenu
        shouldEnableAvatar={avatarVisible}
        shouldEnableJump={false}
        shouldEnableResources={!hideSupportButtons}
        theme={theme}
      />
    </div>
    <div className={kuiperClassNames('post-meta-data')}>
      {renderIcon(`channel-${decorateServiceName(channelName)}`, {
        ariaMode: 'hidden',
      })}
      <span className={kuiperClassNames('post-title')}>{postTitle}</span>
      <Conditional condition={createdByUser && snapshotCreatedAt}>
        <span className={kuiperClassNames('edited-by')}>
          Edited by {createdByUser.fullName}{' '}
          {formatDistanceToNow(new Date(snapshotCreatedAt), {
            addSuffix: true,
          })}
        </span>
      </Conditional>
      <Conditional condition={!isLatest}>
        <Button label="View Latest" onClick={onLatestClick} type="secondary" />
      </Conditional>
    </div>
  </Fragment>
)

LayerHeader.propTypes = {
  avatarVisible: bool,
  channelName: string,
  createdByUser: object,
  hideSupportButtons: bool,
  isLatest: bool,
  onLatestClick: func,
  onLifesaverClick: func,
  postTitle: string,
  snapshotCreatedAt: string,
  theme: string,
}

export default LayerHeader
